import { render, staticRenderFns } from "./group.vue?vue&type=template&id=3d5b3ca0&scoped=true"
import script from "./group.vue?vue&type=script&lang=js"
export * from "./group.vue?vue&type=script&lang=js"
import style0 from "./group.vue?vue&type=style&index=0&id=3d5b3ca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5b3ca0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsGroupHero: require('/home/ticketshoplv/public_html/ticketshop.lt/components/elements/GroupHero.vue').default,ElementsHero: require('/home/ticketshoplv/public_html/ticketshop.lt/components/elements/Hero.vue').default})
